var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-status',{staticClass:"data-table-cell-group__inherit",class:{ 'invisible': !_vm.isInherited },attrs:{"icon":"parent","intent":_vm.$pepper.Intent.WARNING,"title":_vm.$t('sayl.impersonation_inherited')}})
}
var staticRenderFns = []

export { render, staticRenderFns }